import React, { Component } from 'react'
import styled from 'styled-components'
import anime from 'animejs'

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999999;
`

class DirectoryLoader extends Component {
  componentDidMount(){
    anime({
      targets: "#loader-anim",
      opacity: [0.2],
      duration: 1000,
      direction: "alternate",
      loop: true
    })
  }
  render(){
    return (
      <Wrapper>
        <svg id="loader-anim" width="300" viewBox="0 0 600 600" {...this.props}>
          <g>
            <path
              className="st0"
              stroke="#9dbc2d"
              fill="none"
              strokeWidth="13"
              d="M253.1 53.2c0 13.2.1 25.8-.2 38.3 0 1.5-2 3.3-3.6 4.3-25.5 15.7-50.3 32.3-73.6 51.2-22.5 18.2-43.7 37.7-59.2 62.4-14.5 23-21.3 48.4-21.7 75.6-.2 12.8-.5 25.7 3.9 38.1 3.1 8.7 8 16.2 15.2 22.1 8.5 6.8 17.9 7.5 27.9 4.7 12.9-3.7 25.6-8.3 38.6-11.2 32.7-7.2 61.2 1.8 85.5 24.5 15.8 14.6 26.5 32.3 29.5 53.6 4.7 33.4 1 65.4-23.9 90.9-19 19.5-42.4 31.9-69.3 37.1-48.6 9.4-91.4-3-128.7-35.1-29.7-25.5-50.9-56.8-60.4-95.1-3.3-13.2-4.9-27-6.4-40.6-2.1-18.6-.5-37.2 2-55.7 3.5-25.6 10.5-50.4 21.1-74C61.7 173.6 112.4 120.9 180.9 85c22.3-11.7 45.2-22 68.9-30.7 1-.4 1.7-.6 3.3-1.1zM549.5 50.5c0 14 .1 26.5-.1 39.1 0 1.4-1.9 3.1-3.3 4-19.1 12.9-38.6 25.1-57.2 38.6-25.8 18.7-49.9 39.4-69.1 65.2-16.1 21.6-25.2 45.8-27.8 72.6-1.4 14.6-1.8 29 1 43.5 2.3 11.7 7.6 21.8 16.9 29.5 8.3 6.9 17.8 7.9 27.8 5 10.8-3.1 21.5-6.6 32.2-9.8 58.5-17.4 109.9 24.6 120.3 69.2 7.2 31.1 4.8 61.6-14.2 88.5-14.9 21.1-36.6 33.8-60.6 42.3-18.2 6.5-37.2 8.7-56.4 7.4-31.5-2.2-59.4-13.8-83.9-33.6-33.7-27.2-56.8-61.4-66.7-103.8-3.1-13.1-4.6-26.8-5.4-40.3-2.5-44.3 5.9-86.8 24-127.2 19.5-43.4 47.3-81 83.2-112.3 27.8-24.2 59.3-42.8 92.7-58.1 15.1-6.8 30.3-12.9 46.6-19.8z"
            />
          </g>
        </svg>
      </Wrapper>
    )
  }
}

export default DirectoryLoader



// WEBPACK FOOTER //
// ./src/components/loader/directoryLoader.js